@if (loaded()) {
  @if (hasProducts()) {
    <ct-lib-radio-card-group
      class="plan-cards"
      orientation="horizontal"
      [value]="selectedPriceId()"
      (valueChange)="selectedPriceId.set($event)"
      [disabled]="disabled()"
    >
      @for (product of paidProducts(); track product.id) {
        <ct-lib-radio-card
          [value]="product.id"
          [label]="productTitle(product)"
          [disabled]="disabled()"
        >
          @if (isCurrent(product)) {
            <ct-lib-tag radioCardBadge class="current-badge">{{
              'company-tool.snippets.base-booking-modal.current-badge'
                | transloco
            }}</ct-lib-tag>
          } @else if (isRecommended(product)) {
            <ct-lib-tag
              radioCardBadge
              class="recommended-badge"
              [variant]="TagVariant.COUNTER"
              >{{
                'company-tool.snippets.base-booking-modal.recommended-badge'
                  | transloco
              }}</ct-lib-tag
            >
          }
          <p class="plan-price">
            <span class="plan-price-amount">
              {{
                monthlyDisplayAmount(product)
                  | currency
                    : product.currency.toUpperCase()
                    : 'symbol'
                    : '1.0-0'
              }}
            </span>
            <span class="plan-price-interval">
              {{ periodHint(product) }}
            </span>
          </p>
          @if (planKey(product); as key) {
            <ul class="feature-list">
              @for (index of featureIndexes; track index) {
                <li>
                  <fa-icon
                    [icon]="fontawesomeService.light.checkCircle"
                    aria-hidden="true"
                  ></fa-icon>
                  <span
                    [innerHTML]="
                      'company-tool.snippets.base-booking-modal.plans.' +
                        key +
                        '.features.' +
                        index | transloco
                    "
                  ></span>
                </li>
              }
            </ul>
          }
        </ct-lib-radio-card>
      }

      @if (noSubscriptionProduct(); as product) {
        <div class="no-subscription-row">
          <ct-lib-radio-card
            class="no-subscription"
            [value]="product.id"
            [label]="
              'company-tool.snippets.base-booking-modal.no-subscription'
                | transloco
            "
            [disabled]="disabled()"
          >
            @if (isCurrent(product)) {
              <ct-lib-tag radioCardBadge class="current-badge">{{
                'company-tool.snippets.base-booking-modal.current-badge'
                  | transloco
              }}</ct-lib-tag>
            }
          </ct-lib-radio-card>
        </div>
      }
    </ct-lib-radio-card-group>
  }
} @else {
  <div class="loading-wrapper">
    @for (skeleton of [1, 2, 3]; track skeleton) {
      <ngx-skeleton-loader
        appearance="line"
        [theme]="{
          height: '16rem',
          width: '100%',
          'margin-bottom': '0',
          'border-radius': '15px',
        }"
        [animation]="
          themingService.theme === 'dark' ? 'progress-dark' : 'progress'
        "
      ></ngx-skeleton-loader>
    }
  </div>
}
